var map = {
	"./Alpina_Gstaad.jpg": 84,
	"./Backstage_Zermatt.jpg": 85,
	"./Badrutt_St_Moritz.jpg": 86,
	"./Belvedere_Scuol.jpg": 87,
	"./Bergwelt_Grindelwald.jpg": 88,
	"./Chedi_Andermatt.jpg": 89,
	"./Chesa_Randolina_Sils.jpg": 90,
	"./Doldenhorn_Kandersteg.jpg": 91,
	"./Grand_Bellevue_Gstaad.jpg": 92,
	"./Kempinski_Engelberg.jpg": 93,
	"./Kernen_Schoenried_Gstaad.jpg": 94,
	"./Krone_La_Punt.jpg": 95,
	"./Kulm_St_Moritz.jpg": 96,
	"./Meisser_Guarda.jpg": 97,
	"./Palace_Gstaad.jpg": 98,
	"./Radisson_Andermatt.jpg": 99,
	"./Riffelalp_Zermatt.jpg": 100,
	"./Rockresort_Laax.jpg": 101,
	"./Schoenegg_Wengen.jpg": 102,
	"./Schweizerhof_Lenzerheide.jpg": 103,
	"./Schweizerhof_Zermatt.jpg": 104,
	"./Spitzhorn_Saanen.jpg": 105,
	"./Sporthotel_Pontresina.jpg": 106,
	"./Suvretta_St_Moritz.jpg": 107,
	"./Tschuggen_Arosa.jpg": 108,
	"./Waldhaus_st_Moritz.jpg": 109,
	"./Walther_Pontresina.jpg": 110,
	"./Zermatterhof_Zermatt.jpg": 111,
	"./Zurbriggen_Saas.jpg": 112,
	"./guardaval_Lenzerheid.jpg": 113,
	"./jungfrau-wengernalp.jpg": 114
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | placeholder */ 32).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 81;
module.exports = webpackAsyncContext;